import {
  TopNavigationContentMode,
  TopNavigationLeftAction,
  TopNavigationProfile,
  UIActionIcon,
  UIMessagingState,
} from './types';

import { MutationTree } from 'vuex';

export default {
  SET_PAGE_TITLE(state: UIMessagingState, title: string) {
    state.pageTitle = title;
  },

  TRIGGER_CUSTOM_BACK_ACTION(state: UIMessagingState, trigger: boolean) {
    state.customBackActionEvent = trigger;
  },

  START_CUSTOM_BACK_ACTION(state: UIMessagingState) {
    state.customBackActionEvent = true;
  },

  FINISH_CUSTOM_BACK_ACTION(state: UIMessagingState) {
    state.customBackActionEvent = false;
  },

  SET_PAGE_MENU_MODE(state: UIMessagingState, menuMode: string) {
    state.pageMenuMode = menuMode;
  },

  /** @see UIMessagingState.pageNested */
  SET_PAGE_NESTED(state: UIMessagingState, nested: boolean) {
    state.pageNested = nested;
  },

  /**
   * @see UIMessagingState.pageActionRoute
   * @see UIMessagingState.pageActionIcon
   */
  SET_PAGE_ACTION(
    state: UIMessagingState,
    { route, icon }: { route: string; icon: UIActionIcon }
  ) {
    state.pageActionIcon = icon;
    state.pageActionRoute = route;
  },

  /** @see UIMessagingState.pageActionRoute */
  SET_PAGE_ACTION_ROUTE(state: UIMessagingState, route: string) {
    state.pageActionRoute = route;
  },

  SET_TOP_NAVIGATION_PROFILE(
    state: UIMessagingState,
    profile: TopNavigationProfile
  ) {
    state.topNavigationProfile = profile;
  },

  SET_TOP_NAVIGATION_CONTENT_MODE(
    state: UIMessagingState,
    contentMode: TopNavigationContentMode
  ) {
    state.topNavigationContentMode = contentMode;
  },

  SET_TOP_NAVIGATION_LEFT_ACTION(
    state: UIMessagingState,
    leftAction: TopNavigationLeftAction
  ) {
    state.topNavigationLeftAction = leftAction;
  },

  SET_CUSTOM_BACK_ROUTE(state: UIMessagingState, route: string) {
    state.customBackRoute = route;
  },
} as MutationTree<UIMessagingState>;
